import { render } from "./EmailTemplate.vue?vue&type=template&id=f13e8230&scoped=true"
import script from "./EmailTemplate.vue?vue&type=script&lang=js"
export * from "./EmailTemplate.vue?vue&type=script&lang=js"

import "./EmailTemplate.vue?vue&type=style&index=0&id=f13e8230&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f13e8230"]])

export default __exports__